import { SwitchableTenantHierarchyDTO } from 'probonio-shared-ui/api';

export function findTenantInHierarchy(root: SwitchableTenantHierarchyDTO, id: string): SwitchableTenantHierarchyDTO | undefined {
  if (root.tenant.id === id) return root;
  for (const child of root.children) {
    const found = findTenantInHierarchy(child, id);
    if (found) return found;
  }
}

export function flattenTenants(root: SwitchableTenantHierarchyDTO): SwitchableTenantHierarchyDTO[] {
  return [root, ...root.children.flatMap(flattenTenants)];
}
